import { useState } from "react";

import {
    createSignalSightTaskDestination,
    postStoreImpactMappings,
} from "helpers/destinations/createDestination";

import {
    buildImpactMappingsPayload,
    buildSignalSightTaskPayload,
} from "../DestinationCreation.helpers";

/**
 * Destinations configured entirely by their child component's event mapping:
 * Impact (`imcapi`) and SignalSight Task (`sstask`).
 */
const useMappingOnlyDestination = ({
    setModalLoading,
    resetForm,
    completeCreation,
    hostActions,
}) => {
    const [impactDestinationId, setImpactDestinationId] = useState(true);
    const [impactFields, setImpactFields] = useState(null);
    const [signalSightTaskFields, setSignalSightTaskFields] = useState([]);
    const [signalSightTaskName, setSignalSightTaskName] = useState(null);

    const resetOnTypeChange = () => {
        setSignalSightTaskName("");
        setSignalSightTaskFields([]);
    };

    const saveImpactMapping = async () => {
        setModalLoading(true);
        const response = await postStoreImpactMappings(
            impactDestinationId,
            buildImpactMappingsPayload(impactFields),
        );
        if (!response.status) {
            setModalLoading(false);
            return;
        }
        resetForm();
        hostActions.close();
        await completeCreation([impactDestinationId]);
    };

    const saveSignalSightTaskMapping = async () => {
        setModalLoading(true);
        try {
            const response = await createSignalSightTaskDestination(
                buildSignalSightTaskPayload(
                    signalSightTaskName,
                    signalSightTaskFields,
                ),
            );
            setModalLoading(false);
            if (response.status) {
                await completeCreation([response.data.id]);
            }
        } catch (error) {
            console.error("Error saving SignalSight Task mapping:", error);
            setModalLoading(false);
        }
    };

    return {
        setImpactDestinationId,
        setImpactFields,
        setSignalSightTaskFields,
        setSignalSightTaskName,
        resetOnTypeChange,
        saveImpactMapping,
        saveSignalSightTaskMapping,
    };
};

export default useMappingOnlyDestination;
